import axios from 'axios'
import { authRoutes } from '@shared/constants/authRoutes'
import { queryOptions } from '@tanstack/react-query'
import { type Auth0User } from '@/features/account/services/User/types'

export const auth0UserQueryOptions = queryOptions({
  queryKey: ['auth0User'],
  queryFn: async () => {
    const res = await axios.get<Auth0User | void>(authRoutes.ME)
    const data = res.data
    // Auth0 SDK may return 204 No Content when unauthenticated.
    if (res.status === 204 || !data || typeof data !== 'object') return null
    return data
  },
  staleTime: Infinity,
  gcTime: Infinity,
})
